import React from 'react';
import { ArrowRight } from 'lucide-react';

const LinkButton = ({ href, children }) => {
  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: '0.5rem',
        color: '#000',
        textDecoration: 'none',
        fontFamily: 'Inter, sans-serif',
        fontSize: '1.2rem',
        fontWeight: '600',
        letterSpacing: '.5px',
        transition: 'opacity 0.3s',
        cursor: 'pointer'
      }}
      onMouseEnter={(e) => {
        e.target.style.opacity = '0.7';
      }}
      onMouseLeave={(e) => {
        e.target.style.opacity = '1';
      }}
    >
      {children}
      <ArrowRight size={20} strokeWidth={3} color="#000" />
    </a>
  );
};

export default LinkButton;








